<template>
  <div>
    <great></great>
    <perfi-complete></perfi-complete>
    <compliance></compliance>
    <message-suport-client></message-suport-client>
  </div>
</template>
<script>
import Great from "./Great";
import PerfiComplete from "./PerfiComplete";
import Compliance from "./Compliance";
import MessageSuportClient from "../dashboard/client/tools/MessageSuportClient";
export default {
  name: "Welcome",
  components: { MessageSuportClient, Compliance, PerfiComplete, Great },
  data: () => ({}),
  methods: {
    getUserProfile() {
      // let id = this.$store.getters.getUserID;
      return this.$store.dispatch("getClient");
    }
  },
  mounted() {
    //this.getUserProfile();
  }
};
</script>

<style scoped>
.background {
  background-color: #f5f5f5;
}
</style>
